import { render, staticRenderFns } from "./competitivePriceChange.vue?vue&type=template&id=2e811d2f&scoped=true"
import script from "./competitivePriceChange.vue?vue&type=script&lang=js"
export * from "./competitivePriceChange.vue?vue&type=script&lang=js"
import style0 from "./competitivePriceChange.vue?vue&type=style&index=0&id=2e811d2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e811d2f",
  null
  
)

export default component.exports